import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import Button from 'primevue/button';
//import Chart from 'primevue/chart';
import ChartWrapper from './ChartWrapper.vue';
export default {
    components: {
        TabView,
        TabPanel,
        Dropdown,
        Calendar,
        Button,
        ChartWrapper,
    },
    data() {
        return {
            visibleRight: false,
            date3: null,
            selectedCity: null,
            cities: [
                { name: 'Lotto 1', code: 'NY' },
                { name: 'Lotto 2', code: 'RM' },
                { name: 'Lotto 3', code: 'LDN' },
                { name: 'Lotto 4', code: 'IST' },
                { name: 'Lotto 5', code: 'PRS' },
            ],
            lineStylesData: {
                labels: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                ],
                datasets: [
                    {
                        label: 'First Dataset',
                        data: [65, 59, 80, 81, 56, 55, 40],
                        fill: false,
                        tension: 0.4,
                        borderColor: '#42A5F5',
                    },
                    {
                        label: 'Second Dataset',
                        data: [28, 48, 40, 19, 86, 27, 90],
                        fill: false,
                        borderDash: [5, 5],
                        tension: 0.4,
                        borderColor: '#66BB6A',
                    },
                    {
                        label: 'Third Dataset',
                        data: [12, 51, 62, 33, 21, 62, 45],
                        fill: true,
                        borderColor: '#FFA726',
                        tension: 0.4,
                        backgroundColor: 'rgba(255,167,38,0.2)',
                    },
                ],
            },
            basicOptions: {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057',
                        },
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#495057',
                        },
                        grid: {
                            color: '#ebedef',
                        },
                    },
                    y: {
                        ticks: {
                            color: '#495057',
                        },
                        grid: {
                            color: '#ebedef',
                        },
                    },
                },
            },
        };
    },
};
